export default function ListSection() {
  const SECTIONS = document.querySelectorAll('.mtt-list-section')
  if (SECTIONS.length > 0) {
    for (let i = 0; i < SECTIONS.length; i++) {
      const SECTION = SECTIONS[i]
      const ITEMS = SECTION.querySelectorAll('.mtt-list-section__item.hidden')
      const NUMBER_EIGHT = SECTION.querySelector('.mtt-list-section__item.number-eight')
      const BUTTON = SECTION.querySelector('.mtt-list-section__show-more .button')
      const BUTTON_TEXTS = {
        show_more: BUTTON?.innerHTML?.trim() ?? '',
        show_less: BUTTON?.getAttribute('data-show-less') ?? ''
      }

      if (ITEMS.length > 0 && BUTTON) {
        BUTTON.addEventListener('click', () => {
          // toggle items
          for (let i = 0; i < ITEMS.length; i++) {
            ITEMS[i].classList.toggle('hide')
          }
          NUMBER_EIGHT.classList.toggle('hide')

          BUTTON.parentElement.classList.toggle('after')

          // toggle text
          BUTTON.innerHTML = ITEMS[0].classList.contains('hide')
            ? BUTTON_TEXTS.show_more
            : BUTTON_TEXTS.show_less
        })
      }
    }
  }
}
